












import Vue, { PropType } from 'vue';

import Signature from '@/containers/signature';

import { DocumentImage, DynamicDocumentItem, DynamicDocumentItemData } from '@/types';

import documentCtxMixin from '../document-ctx';

export default documentCtxMixin.extend({
  components: {
    Signature,
  },

  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
  },

  computed: {
    meta(): Record<string, any> {
      return this.item.meta ?? {};
    },

    /**
     * On a questionnaire the drawing is uploaded as a Document, like every other image on the form,
     * and the answer keeps the URL that comes back. Without a persistence strategy (the installation
     * flow) this is null and the dialog falls back to the device's library cache — which is right
     * there, because the library sync is what uploads it.
     */
    upload(): ((file: File) => Promise<string>) | null {
      return this.ctx?.uploadPhoto ? this.uploadSignature : null;
    },
  },

  methods: {
    async uploadSignature(file: File): Promise<string> {
      const image: DocumentImage = await this.ctx.uploadPhoto!(file, this.item);

      return image.url;
    },
  },
});
